export const CORE_PRODUCTION = 'production';
export const CORE_DEVELOPMENT = 'development';

const prefix = 'CORE_';
export const TIMER_KEY = `${prefix}TIMER_KEY`;

export const FIELD_REQUIRED = 'field_required';
export const FIELD_MIN_LENGTH = 'min_length_field';
export const INCORRECT_DATE = 'incorrect_date';
